module.exports = __webpack_public_path__ + "static/img/10003 (2).b7c13df.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10003 (2).webp
// module id = YgFi
// module chunks = 14